"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./RekognitionClient"), exports);
tslib_1.__exportStar(require("./Rekognition"), exports);
tslib_1.__exportStar(require("./commands/CompareFacesCommand"), exports);
tslib_1.__exportStar(require("./commands/CreateCollectionCommand"), exports);
tslib_1.__exportStar(require("./commands/CreateProjectCommand"), exports);
tslib_1.__exportStar(require("./commands/CreateProjectVersionCommand"), exports);
tslib_1.__exportStar(require("./commands/CreateStreamProcessorCommand"), exports);
tslib_1.__exportStar(require("./commands/DeleteCollectionCommand"), exports);
tslib_1.__exportStar(require("./commands/DeleteFacesCommand"), exports);
tslib_1.__exportStar(require("./commands/DeleteProjectCommand"), exports);
tslib_1.__exportStar(require("./commands/DeleteProjectVersionCommand"), exports);
tslib_1.__exportStar(require("./commands/DeleteStreamProcessorCommand"), exports);
tslib_1.__exportStar(require("./commands/DescribeCollectionCommand"), exports);
tslib_1.__exportStar(require("./commands/DescribeProjectsCommand"), exports);
tslib_1.__exportStar(require("./pagination/DescribeProjectsPaginator"), exports);
tslib_1.__exportStar(require("./commands/DescribeProjectVersionsCommand"), exports);
tslib_1.__exportStar(require("./pagination/DescribeProjectVersionsPaginator"), exports);
tslib_1.__exportStar(require("./waiters/waitForProjectVersionRunning"), exports);
tslib_1.__exportStar(require("./waiters/waitForProjectVersionTrainingCompleted"), exports);
tslib_1.__exportStar(require("./commands/DescribeStreamProcessorCommand"), exports);
tslib_1.__exportStar(require("./commands/DetectCustomLabelsCommand"), exports);
tslib_1.__exportStar(require("./commands/DetectFacesCommand"), exports);
tslib_1.__exportStar(require("./commands/DetectLabelsCommand"), exports);
tslib_1.__exportStar(require("./commands/DetectModerationLabelsCommand"), exports);
tslib_1.__exportStar(require("./commands/DetectProtectiveEquipmentCommand"), exports);
tslib_1.__exportStar(require("./commands/DetectTextCommand"), exports);
tslib_1.__exportStar(require("./commands/GetCelebrityInfoCommand"), exports);
tslib_1.__exportStar(require("./commands/GetCelebrityRecognitionCommand"), exports);
tslib_1.__exportStar(require("./pagination/GetCelebrityRecognitionPaginator"), exports);
tslib_1.__exportStar(require("./commands/GetContentModerationCommand"), exports);
tslib_1.__exportStar(require("./pagination/GetContentModerationPaginator"), exports);
tslib_1.__exportStar(require("./commands/GetFaceDetectionCommand"), exports);
tslib_1.__exportStar(require("./pagination/GetFaceDetectionPaginator"), exports);
tslib_1.__exportStar(require("./commands/GetFaceSearchCommand"), exports);
tslib_1.__exportStar(require("./pagination/GetFaceSearchPaginator"), exports);
tslib_1.__exportStar(require("./commands/GetLabelDetectionCommand"), exports);
tslib_1.__exportStar(require("./pagination/GetLabelDetectionPaginator"), exports);
tslib_1.__exportStar(require("./commands/GetPersonTrackingCommand"), exports);
tslib_1.__exportStar(require("./pagination/GetPersonTrackingPaginator"), exports);
tslib_1.__exportStar(require("./commands/GetSegmentDetectionCommand"), exports);
tslib_1.__exportStar(require("./pagination/GetSegmentDetectionPaginator"), exports);
tslib_1.__exportStar(require("./commands/GetTextDetectionCommand"), exports);
tslib_1.__exportStar(require("./pagination/GetTextDetectionPaginator"), exports);
tslib_1.__exportStar(require("./commands/IndexFacesCommand"), exports);
tslib_1.__exportStar(require("./commands/ListCollectionsCommand"), exports);
tslib_1.__exportStar(require("./pagination/ListCollectionsPaginator"), exports);
tslib_1.__exportStar(require("./commands/ListFacesCommand"), exports);
tslib_1.__exportStar(require("./pagination/ListFacesPaginator"), exports);
tslib_1.__exportStar(require("./commands/ListStreamProcessorsCommand"), exports);
tslib_1.__exportStar(require("./pagination/ListStreamProcessorsPaginator"), exports);
tslib_1.__exportStar(require("./commands/RecognizeCelebritiesCommand"), exports);
tslib_1.__exportStar(require("./commands/SearchFacesCommand"), exports);
tslib_1.__exportStar(require("./commands/SearchFacesByImageCommand"), exports);
tslib_1.__exportStar(require("./commands/StartCelebrityRecognitionCommand"), exports);
tslib_1.__exportStar(require("./commands/StartContentModerationCommand"), exports);
tslib_1.__exportStar(require("./commands/StartFaceDetectionCommand"), exports);
tslib_1.__exportStar(require("./commands/StartFaceSearchCommand"), exports);
tslib_1.__exportStar(require("./commands/StartLabelDetectionCommand"), exports);
tslib_1.__exportStar(require("./commands/StartPersonTrackingCommand"), exports);
tslib_1.__exportStar(require("./commands/StartProjectVersionCommand"), exports);
tslib_1.__exportStar(require("./commands/StartSegmentDetectionCommand"), exports);
tslib_1.__exportStar(require("./commands/StartStreamProcessorCommand"), exports);
tslib_1.__exportStar(require("./commands/StartTextDetectionCommand"), exports);
tslib_1.__exportStar(require("./commands/StopProjectVersionCommand"), exports);
tslib_1.__exportStar(require("./commands/StopStreamProcessorCommand"), exports);
tslib_1.__exportStar(require("./pagination/Interfaces"), exports);
tslib_1.__exportStar(require("./models/index"), exports);
//# sourceMappingURL=index.js.map